var initialHeight;

$(function() {
	$("#catalog-sort-by").change(function() {
		var selectedUrl = $(this).children(":selected").attr("data-href");
		document.location.href = selectedUrl;
	});

	$("body").on("click", "#supplier-contact-info-toggle", function() {
		$("#supplier-contact-info").slideToggle();
		$(this).toggleClass("open");
	});

	$("body").on("click", "#supplier-menu-toggle", function() {
		if ($("html").hasClass("phone")) {
			var topValue = $("#masthead").height() + $("#supplier-menu-toggle").height() + "px";
			$(".nav.show-on-phone").attr("data-top-value-original", topValue);
			$(".nav.show-on-phone").css("top", topValue).slideToggle();
		} else {
			$(".nav.show-on-desktop").slideToggle();
		}

		$(this).toggleClass("open");
	});

	$(".sp-home .view-more-link").click(function(e) {
		e.preventDefault();

		var aboutBody = $("#sp-profile-body");
		var closedHeight = $(this).data("initial-height");
		var openHeight = $("#sp-profile-body")[0].scrollHeight;

		aboutBody.toggleClass("expanded");
		// if the rest of the about text is hidden, show it! Otherwise hide it.
		if (aboutBody.height() == closedHeight) {
			aboutBody.css("height", openHeight);
			$(this).text("See less");
		} else {
			aboutBody.css("height", closedHeight);
			$(this).text("See more");
		}
	});

	if ($("html").hasClass("responsive-content") && $("html").hasClass("phone")) {
		// For more Products bricklet (PAs)
		var fmpBricklet = $("html.sm.phone .bricklet.for-more-products").detach();
		fmpBricklet.appendTo("html.sm.phone #main-content");
		fmpBricklet.show();

		// Making entire area listing blocks clickable on phone
		$(".area-listing .area-listing-item.linkable-block").click(function() {
			var destinationUrl = $(this).find(".item-title").attr("href");
			document.location.href = destinationUrl;
		});
	}
});

$( window ).on( "orientationchange", function() {
	calculateSupplierSkinWindowDimensions();
});

function calculateSupplierSkinWindowDimensions() {
	if ($("#supplier-skin-wrapper #supplier-info").length) {
		// calculating the initial height to make the supplier skin window on page load
		var contactInfoPosition = $("#supplier-skin-wrapper #supplier-info .contact-info").position().top;
		var addressHeight = $("#supplier-skin-wrapper #supplier-info .contact-info .supplier-address").outerHeight(true);
		initialHeight = contactInfoPosition + addressHeight + 25;

		// set initial height of supplier skin window
		$("#supplier-skin-wrapper").height(initialHeight);
		$("#supplier-skin-accordion-control").removeClass("expanded");

		// get total height of window and accordion bar
		var accordionControlHeight = $("#supplier-skin-accordion-control").outerHeight(true);

		var contentTopMargin = initialHeight + accordionControlHeight + 15;

		$("div#main-content").css("margin-top", contentTopMargin);
	}
}
